import { render, staticRenderFns } from "./FloorControl.vue?vue&type=template&id=0fafbe5e&scoped=true&"
import script from "./FloorControl.vue?vue&type=script&lang=js&"
export * from "./FloorControl.vue?vue&type=script&lang=js&"
import style0 from "./FloorControl.vue?vue&type=style&index=0&id=0fafbe5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafbe5e",
  null
  
)

export default component.exports